/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { tableHead } from './tableHead';

import { getQuarterlyCms } from '../Store/action';

import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const DisplayCmsDrug = () => {
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const {
    displayObj: { startQtr: getQuarter, quarterlyCms: getQuarterlyCmsDrugList },
  } = useSelector((state) => state?.sharedState?.QuarterlyCmsDrugReducer);
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [cmsDrug, setCmsDrug] = React.useState();
  // full screen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // converting date to required payload
  function getQuarterDates(quarter) {
    const year = parseInt(quarter.slice(-4));
    const quarterNum = parseInt(quarter.slice(0, 1));
    let startDate;
    let endDate;

    switch (quarterNum) {
      case 1:
        startDate = new Date(year, 0, 1);
        endDate = new Date(year, 2, 31);
        break;
      case 2:
        startDate = new Date(year, 3, 1);
        endDate = new Date(year, 5, 30);
        break;
      case 3:
        startDate = new Date(year, 6, 1);
        endDate = new Date(year, 8, 30);
        break;
      case 4:
        startDate = new Date(year, 9, 1);
        endDate = new Date(year, 11, 31);
        break;
    }

    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    const startStr = startDate?.toLocaleDateString('en-US', options);
    const endStr = endDate?.toLocaleDateString('en-US', options);

    return { startDate: startStr, endDate: endStr };
  }
  const qtr = getQuarterDates(getQuarter);

  // cms drug api
  // React.useEffect(() => {
  //   dispatch(
  //     getQuarterlyCms({
  //       startDate: qtr.startDate,
  //       endDate: qtr.endDate,
  //     })
  //   );
  // }, []);
  React.useEffect(() => {
    let data = getQuarterlyCmsDrugList?.quarterlyCmsDrugReportVO;
    data = data?.map((item) => {
      return {
        ...item,
        unitrebateAmt: item.unitrebateAmt
          ? item.unitrebateAmt.toFixed(4)
          : '0.0000',
        unitPerPackageSize: item.unitPerPackageSize
          ? item.unitPerPackageSize.toFixed(3)
          : '0.000',
        // ? '$' +
        //   item.unitrebateAmt?.toLocaleString('en-US', {
        //     minimumFractionDigits: 2,
        //   })
        // : '$0.00',
      };
    });
    setCmsDrug(data);
  }, [getQuarterlyCmsDrugList]);
  // pdf header
  let firstInfo = '';

  firstInfo = `Quarter: ${getQuarter}`;
  return (
    <>
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space devider-line pb-0">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display Quarterly CMS Drug "
          />
          <Spinner load={spinnerLoader} />
          {!fullScreenView && (
            <>
              <div className="panel custom-fieldset">
                <div className="custom-check">
                  <div className="form-wrapper">
                    <div className="mui-custom-form input-md">
                      <div className="col-10">
                        <TextField
                          id="Quarter"
                          label="Quarter"
                          fullWidth
                          inputProps={{ id: 'Quarter' }}
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={getQuarter}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner"
          >
            <TableGrid
              ref={gridRef}
              data-testid="drug-type"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={cmsDrug}
              columnDefs={tableHead}
              exportFile
              isScrollOn
              animateRows
              sideBar={false}
              fileName="QuarterlyCMSDrug"
              reportName="Quarterly CMS Drug Report"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
                CheckBoxSelectedForRCellRender: (cellInfo) => {
                  return (
                    <>
                      <div className="tbl-checkbox frr-checkbox-no-label">
                        <FormControlLabel
                          data-testid="checkBox"
                          label="checkbox"
                          control={<Checkbox color="primary" />}
                          disabled={parseInt(cellInfo.value) !== 1}
                          checked={parseInt(cellInfo.value) === 1}
                          // value={parseInt(cellInfo.value, [0, 1]) === 1}
                        />
                      </div>
                    </>
                  );
                },
              }}
              onCellFocused={onCellFocused}
              info={{ firstInfo }}
              showExportPdfOption={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayCmsDrug;
